const jwt_customizer = {
    general: 'هنگام سفارشی‌سازی ادعاهای توکن خطایی رخ داد. لطفاً بعداً دوباره تلاش کنید.',
    can_not_create_for_admin_tenant: 'نمی‌توان سفارشی‌کننده توکن برای مستأجر مدیر ایجاد کرد.',
};
export default Object.freeze(jwt_customizer);
